import React from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Select } from 'react-magma-dom';

import NumericalOption from './NumericalOption';
import CategoricalOption from './CategoricalOption';
import { useSelector } from 'react-redux';
import { getCorrectVarTypes } from '../../../../../../store/dataset/dataset/selectors';

const types = [
  {
    value: 'numerical',
    label: <NumericalOption />
  },
  {
    value: 'categorical',
    label: <CategoricalOption />
  }
];

const ParameterComponent = props => {
  const {
    name,
    targetType,
    isSelected,
    onSelectionChange,
    onTypeChange
  } = props;

  const correctParamsFromStore = useSelector(state => getCorrectVarTypes(state));

  const handleTypeChange = ({ selectedItem }) => {
    onTypeChange(name, selectedItem.value);
  };

  return (
    <div className="main-checkbox-filter pl-30 mb-5 flex-justify-sp_between flex-align-center">
      <Checkbox
        labelText={name}
        checked={isSelected}
        hasError
        onChange={event => onSelectionChange(event, name)}
        labelStyle={{ fontSize: '14px' }}
      />

      <Select
        labelStyle={{ padding: 0, margin: 0, display: 'block' }}
        inputStyle={{ minWidth: 160, border: 0, fontSize: '14px' }}
        menuStyle={{ fontSize: '14px' }}
        labelText={targetType}
        isLabelVisuallyHidden
        items={types}
        disabled={!isSelected || (targetType === 'categorical' && correctParamsFromStore[name] === 'categorical')}
        selectedItem={types.find(({ value }) => value === targetType)}
        onSelectedItemChange={handleTypeChange}
      />
    </div>
  );
};


ParameterComponent.propTypes = {
  name: PropTypes.string.isRequired,
  targetType: PropTypes.oneOf(['numerical', 'categorical']).isRequired,
  isSelected: PropTypes.bool.isRequired,

  onTypeChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired
};

export default ParameterComponent;
